const BORDER_STATE_COLORS = {
  SUCCESS: '--c-color-green-400',
  DEFAULT: '--c-color-gray-200',
  ERROR: '--c-color-red-400',
};

const INFO_STATE_COLORS = {
  SUCCESS: '--c-color-gray-300',
  DEFAULT: '--c-color-gray-300',
  ERROR: '--c-color-red-400',
};

const LABEL_STATE_COLORS = {
  SUCCESS: '--c-color-gray-500',
  DEFAULT: '--c-color-gray-300',
  ERROR: '--c-color-red-400',
};

export {
  BORDER_STATE_COLORS,
  INFO_STATE_COLORS,
  LABEL_STATE_COLORS,
};
